import { render, staticRenderFns } from "./popular-searches.vue?vue&type=template&id=510c8f47&scoped=true&"
import script from "./popular-searches.vue?vue&type=script&lang=js&"
export * from "./popular-searches.vue?vue&type=script&lang=js&"
import style0 from "./popular-searches.vue?vue&type=style&index=0&id=510c8f47&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c8f47",
  null
  
)

export default component.exports